module.exports = __webpack_public_path__ + "0.1.0/img/thrombus.7a7e109f.png";